<template>
  <a-icon :component="component"></a-icon>
</template>

<script>
export default {
  name: 'DownIcon',
  data () {
    return {
      component: {
        template: `
          <svg viewBox="0 0 1024 1024" width="1em" height="1em">
            <path d="M392.448255 0h238.494873v635.98633h-238.494873z" p-id="1368"></path>
            <path d="M495.00105 1016.783145L155.543347 677.325441A23.849487 23.849487 0 0 1 172.237988 635.98633h678.915407a23.849487 23.849487 0 0 1 16.694641 41.339111l-338.662721 339.457704a23.849487 23.849487 0 0 1-34.184265 0z" p-id="1369"></path><path d="M392.448255 0h238.494873v635.98633h-238.494873z" p-id="1370"></path>
            <path d="M495.00105 1016.783145L155.543347 677.325441A23.849487 23.849487 0 0 1 172.237988 635.98633h678.915407a23.849487 23.849487 0 0 1 16.694641 41.339111l-338.662721 339.457704a23.849487 23.849487 0 0 1-34.184265 0z" p-id="1371"></path>
          </svg>
        `
      }
    }
  }
}
</script>
